module.exports = __webpack_public_path__ + "img/c04_unittechwarwagonchampion_Normal_ua.1a02ce7c.webp";